import { validate } from 'validate.js';
import { getCurrentLanguage } from '../utils/currentLanguage.ts';
import { getConstraints } from './common.js';
function ValidateUser(valueToValidate, valueIndex) {
    const localizedConstraints = getConstraints(getCurrentLanguage());
    const constraintsFirstSection = {
        FirstName: localizedConstraints.FirstName,
        LastName: localizedConstraints.LastName,
        PhoneNumber: localizedConstraints.PhoneNumber,
        Email: localizedConstraints.Email,
        RepeatedEmail: localizedConstraints.RepeatedEmail,
        StreetName: localizedConstraints.StreetName,
        PostalCode: localizedConstraints.PostalCode,
        PostalCity: localizedConstraints.PostalCity,
        CountryId: localizedConstraints.CountryId,
    };
    const constraintsEmail = {
        Email: localizedConstraints.Email,
        RepeatedEmail: localizedConstraints.RepeatedEmail,
    };
    const constraintsLastSection = {
        Password: localizedConstraints.Password,
        RepeatedPassword: localizedConstraints.RepeatedPassword,
    };
    const allConstraints = {
        ...constraintsFirstSection,
        ...constraintsLastSection,
    };
    if (valueIndex != null && valueIndex !== 2) {
        if (valueIndex === 0) {
            return validate({ ...valueToValidate }, constraintsFirstSection, { format: 'detailed' });
        }
        if (valueIndex === 'RepeatedPassword') {
            return validate({ ...valueToValidate }, constraintsLastSection, { format: 'detailed' });
        }
        if (valueIndex === 'RepeatedEmail') {
            return validate({ ...valueToValidate }, constraintsEmail, { format: 'detailed' });
        }
        return validate.single(valueToValidate[valueIndex], allConstraints[valueIndex], { format: 'detailed' });
    }
    else {
        return validate({ ...valueToValidate }, allConstraints, { format: 'detailed' });
    }
}
export { ValidateUser };
